<template>
  <b-container
    :class="
      black ? 'mf_fp_container_bl pb-5 pt-5 fp_view ' : 'pb-5 pt-5 fp_view customCompModal'
    "
  >
    <b-row class="mf_1row">
      <b-col cols="12" lg="4">
        <Mockup src="fp_select_mockup.svg" />
      </b-col>
      <b-col cols="12" lg="8" class="mf_fp_col_title">
        <TitleBig
          content="Votre portefeuille d'investissement personnalisé en 5 minutes"
          :black="black"
        />
        <TitleFree />
        <hr />
        <div>
          <p :class="black ? 'mf_subtitle_bl' : 'mf_subtitle'">
            Construisez, Optimisez & Comparez des portefeuilles d'ETF autant de fois
            que vous le souhaitez !
          </p>
          <p :class="black ? 'mf_title_text_bl mt-5' : 'mf_title_text mt-5'">
            Pour cela, indiquez-nous vos critères puis ajoutez des ETF à votre
            portefeuille. Notre algorithme Home Made se chargera de
            l'optimisation.
          </p>
          <p :class="black ? 'mf_title_text_bl mt-5' : 'mf_title_text mt-5'">
            Pour plus d'information consultez notre article
            <a href="/notre-vue-des-marchés/investir-sur-les-etf-avec-notre-moteur-depargne">ici</a>
          </p>
        </div>
      </b-col>
    </b-row>
    <hr />
    <b-row class="mf_2row">
      <b-col sm-6 class="text-center">
        <StepBloc
          title="Étape 1"
          subtitle="Définissez vos critères"
          :black="black"
        />
        <BlocInvestissement :amount="amount" :black="black" />
        <BlocPlacement :year="year" :black="black" />
      </b-col>
      <b-col sm="6" class="fp_colImg">
        <img class="mf_sm_img" src="./comps/fp_logo.svg" alt="fp_logo" />
      </b-col>
    </b-row>
    <hr />
    <b-col class="mf_3row mt-12">
      <b-col xs="12" class="mb-4">
        <StepBloc
          title="Étape 2"
          subtitle="Sélectionner l'enveloppe et la platforme sur laquelle vous voulez investir"
        />
      </b-col>
      <b-row class="mt-10">
        <b-col xs="12" sm="6">
          <b-row class="select_row_align">
            <b-col sm="9" offset-sm="1">
              <!-- FUTURE BEAU SELECT A PEAUFINER -->
              <!-- <Select :content="assets" property="name_french" title="Classe d'a" /> -->
              <select
                :class="
                  black
                    ? 'form-select mf_bg_bl form-select-sm'
                    : 'form-select mf_bg form-select-sm'
                "
                v-model="contract"
              >
                <option disabled selected value="null">Contrat</option>
                <option
                  v-for="contract in conts"
                  :key="contract.id"
                  :value="contract"
                >
                  {{ contract.name }}
                </option>
              </select>
            </b-col>
            <b-col sm="1">
              <ModalInfo
                title="Information sur les classes d'actifs"
                content=" <p>
          Sur myfo vous retrouverez les principales enveloppes telles que :
        </p>
        <p>
          - Assurance Vie <br>- Compte Titres <br>- PEA <br>- PE
        </p>
        <p>
          Investir sur différentes enveloppes permet de bénéficier des différents avantages fiscaux et d'avoir accès au meilleure opportunités d'investissements.
        </p>"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col xs="12">
          <b-row class="select_row_align">
            <b-col sm="9" offset-sm="1">
              <select
                :class="
                  black
                    ? 'form-select mf_bg_bl form-select-sm'
                    : 'form-select mf_bg form-select-sm'
                "
                v-model="platform"
                :disabled="contract === null ? true : false"
              >
                <option disabled selected value="null">Platform</option>
                <option
                  v-for="platform in filteredPlatforms(contract)"
                  :key="platform.id"
                  :value="platform"
                >
                  {{ platform.name }}
                </option>
              </select>
            </b-col>
            <b-col sm="1">
              <ModalInfo
                title="Information sur les platforme disponibles"
                content="   <p>
        Vous avez accès ici aux principales platformes d'investissement en ligne françaises.
      </p>
      <p>
        Ainsi, sur myfo, vous retrouverez des ETF répartis sur des centaines de
        secteurs.
      </p>
      <p>
        Vous retrouverez par exemple les plateformes suivantes :
      </p>
      <ul>
        <li>Fortuneo</li>
        <li>Boursorama</li>
        <li>Bourse Direct</li>
        <li>Linxea</li>
      </ul>
      <p>Et plus de 50 autres !</p>"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    <b-col class="mf_3row mt-12">
      <b-col xs="12" class="mb-4">
        <StepBloc
          title="Étape 3"
          subtitle="Ajouter des ETF à votre portefeuille à l'aide des filtres proposés"
        />
      </b-col>
      <b-row class="mt-10">
        <b-col xs="12" sm="6">
          <b-row class="select_row_align">
            <b-col sm="9" offset-sm="1">
              <!-- FUTURE BEAU SELECT A PEAUFINER -->
              <!-- <Select :content="assets" property="name_french" title="Classe d'a" /> -->
              <select
                :class="
                  black
                    ? 'form-select mf_bg_bl form-select-sm'
                    : 'form-select mf_bg form-select-sm'
                "
                v-model="asset_class"
                :disabled="platform === null ? true : false"
              >
                <option disabled selected value="null">Classe d'actifs</option>
                <option
                  v-for="asset_class in filteredAssets(contract, platform)"
                  :key="asset_class.id"
                  :value="asset_class"
                >
                  {{ asset_class.name_french }}
                </option>
              </select>
            </b-col>
            <b-col sm="1">
              <ModalInfo
                title="Information sur les classes d'actifs"
                content=" <p>
          Sur myfo vous retrouverez les principales classe d'actifs telles que :
        </p>
        <p>
          - Actions <br>- Obligations <br>- Monétaires <br>- Alternatifs (Ensemble des autres classe d'actif)
        </p>
        <p>
          Investir sur différentes classe d'actif permet de diversifier son portefeuille et ainsi diminuer son risque.
        </p>"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col xs="12">
          <b-row class="select_row_align">
            <b-col sm="9" offset-sm="1">
              <select
                :class="
                  black
                    ? 'form-select mf_bg_bl form-select-sm'
                    : 'form-select mf_bg form-select-sm'
                "
                v-model="sector"
                :disabled="asset_class === null ? true : false"
              >
                <option disabled selected value="null">Sector</option>
                <option
                  v-for="sector in filteredSectors(contract, platform, asset_class)"
                  :key="sector.id"
                  :value="sector"
                >
                  {{ sector.name_french }}
                </option>
              </select>
            </b-col>
            <b-col sm="1">
              <ModalInfo
                title="Information sur les secteurs disponibles"
                content="   <p>
        Un ETF suit la performance d'un ensemble de valeurs qui sont réparties
        selon différentes thématiques bien précises.
      </p>
      <p>
        Ainsi, sur myfo, vous retrouverez des ETF répartis sur des centaines de
        secteurs.
      </p>
      <p>
        Vous retrouverez par exemple les secteurs suivants :
      </p>
      <ul>
        <li>Biotechnologie et Santé</li>
        <li>Matières Premières</li>
        <li>Energie</li>
        <li>Actions croissance Europe</li>
        <li>Global</li>
        <li>Global : Ensemble des plus grosses capitalisations mondiales</li>
        <li>Or</li>
        <li>Obligations vertes</li>
      </ul>
      <p>Et plus de 200 autres !</p>"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    <b-row class="mf_4row mt-5">
      <TableFP
        :sector="sector"
        :asset_class="asset_class"
        :contract="contract"
        :platform="platform"
        :secs="secs"
        @getChecked="addSec($event)"
        :black="black"
        :securityHasContract="securityHasContract"
        :securityHasPlatform="securityHasPlatform"
      />
    </b-row>
    <b-row class="mf_5row">
      <ModalPortefeuille
        :sec="sec"
        :year="year"
        :amount="amount"
        :platform="platform"
        :contract="contract"
        :token="token"
      />
    </b-row>
  </b-container>
</template>
<script>
import ModalInfo from "../components/ModalInfo.vue";
import TableFP from "../components/TableFP.vue";
import Mockup from "../components/Mockup.vue";
import TitleBig from "../components/TitleBig.vue";
import TitleFree from "../components/TitleFree.vue";
import StepBloc from "./comps/StepBloc.vue";
import ModalPortefeuille from "./comps/ModalPortefeuille.vue";
import BlocInvestissement from "./comps/BlocInvestissement.vue";
import BlocPlacement from "./comps/BlocPlacement.vue";
import Select from "../components/Select.vue";

export default {
  props: [
    "securities",
    "token",
    "route",
    "black",
  ],
  components: {
    ModalInfo,
    ModalPortefeuille,
    TableFP,
    Mockup,
    TitleBig,
    TitleFree,
    StepBloc,
    BlocPlacement,
    BlocInvestissement,
    Select
  },
  data() {
    return {
      sector: null,
      asset_class: null,
      contract: null,
      platform: null,
      secs: [],
      conts: [],
      projs: [],
      sec: [],
      amount: 10000,
      year: 5,
    };
  },
  mounted() {
    this.securities.forEach(security => {
      this.secs.push(security);

      // Generate contract array from securities' contracts
      security.contracts.forEach(contract => {
        if(!this.conts.find(element => element.id == contract.id))
        {
          this.conts.push(contract);
        }
      })
    });

    this.secs.sort((a, b) => {
      if (a.esg_score_aggregated > b.esg_score_aggregated) return -1;
      if (a.esg_score_aggregated < b.esg_score_aggregated) return 1;
      return 0;
    });
    this.addRaw();
  },
  computed: {
    total() {
      var tot = 0;
      this.projs.forEach(project => {
        if (project.security != null) {
          tot += project.security.esg_score_aggregated;
        }
      });
      return tot;
    }
  },
  methods: {
    addSec(item) {
      if (!this.sec.find(e => e.id === item.id)) {
        this.sec.push(item);
      } else {
        this.sec = this.sec.filter(i => i.id !== item.id);
      }
    },
    securityHasPlatform(security, platform)
    {
      let ret = false;
      security.platforms.forEach(plat => {
        if(plat.id == platform.id)
        {
          ret = true;
        }
      });
      return ret;
    },
    securityHasContract(security, contract)
    {
      let ret = false;
      security.contracts.forEach(cont => {
        if(cont.id == contract.id)
        {
          ret = true;
        }
      });
      return ret;
    },
    filteredPlatforms(selectedContract) {
      let platforms = [];
      if(selectedContract != null)
      {
        this.secs.forEach(security => {
          security.contracts.forEach(contract => {
            if(contract.id == selectedContract.id)
            {
              platforms.push(...contract.platforms);
            }
          });
        });

        // Remove duplicates
        platforms = [...new Map(platforms.map(v => [v.id, v])).values()]

        // Sort alphabetically
        platforms.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });

      }
      return platforms;
    },
    filteredAssets(selectedContract, selectedPlatform) {
      let assets = [];
      if(selectedPlatform != null)
      {
        this.secs.forEach(security => {
          security.contracts.forEach(contract => {
            if(contract.id == selectedContract.id)
            {
              contract.platforms.forEach(platform => {
                if(platform.id == selectedPlatform.id)
                {
                  assets.push(security.asset_class);
                }
              });
            }
          });
        });

        // Remove duplicates
        assets = [...new Map(assets.map(v => [v.id, v])).values()]

        // Sort alphabetically
        assets.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
      }
      return assets;
    },
    filteredSectors(selectedContract, selectedPlatform, selectedAsset)
    {
      let sectors = [];
      if(selectedAsset != null)
      {
        this.secs.forEach(security => {
          if(security.asset_class.id == selectedAsset.id)
          {
            security.contracts.forEach(contract => {
              if(contract.id == selectedContract.id)
              {
                contract.platforms.forEach(platform => {
                  if(platform.id == selectedPlatform.id)
                  {
                    sectors.push(security.sector);
                  }
                });
              }
            });
          }
        });

        // Remove duplicates
        sectors = [...new Map(sectors.map(v => [v.id, v])).values()]

        // Sort alphabetically
        sectors.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
      }
      return sectors;
    },
    modalId(i) {
      return "modal" + i;
    },
    addRaw() {
      this.projs.push({
        id: null,
        asset_class: null,
        sector: null,
        security: null,
        esg_score_aggregated: 0
      });
    },
  }
};
</script>
<style lang="scss">
@import "../../../../../../resources/sass/_variables.scss";

.mf_fp_container_bl {
  background: #121212;

  .mf_subtitle_bl {
    font: var(--unnamed-font-style-normal) normal
      var(--unnamed-font-weight-bold) var(--unnamed-font-size-35) /
      var(--unnamed-line-spacing-40) var(--unnamed-font-family-segoe-ui);
    letter-spacing: var(--unnamed-character-spacing-0);
    color: var(--unnamed-color-ffffff);
    text-align: left;
    font: normal normal bold 35px/40px Segoe UI;
    letter-spacing: 0px;
    color: #ffffff;
  }

  .mf_title_text_bl {
    font: var(--unnamed-font-style-normal) normal
      var(--unnamed-font-weight-normal) var(--unnamed-font-size-30) /
      var(--unnamed-line-spacing-40) var(--unnamed-font-family-segoe-ui);
    letter-spacing: var(--unnamed-character-spacing-0);
    color: var(--unnamed-color-ffffff);
    text-align: left;
    font: normal normal normal 30px/40px Segoe UI;
    letter-spacing: 0px;
    color: #ffffff;
  }
  hr {
    color: $vlt_grey_color !important;
    height: 0px !important;
    margin-top: 4vh !important;
    margin-bottom: 4vh !important;
    padding: 0px;
  }
}

.select_row_align {
  align-items: center;
}

hr {
  color: $vlt_grey_color !important;
  height: 0px !important;
  margin-top: 4vh !important;
  margin-bottom: 4vh !important;
  padding: 0px;
  background: $vlt_grey_color !important;
}

// =====TABLE FP======
thead {
  // background: $bg_color;
  color: $lt_grey_color;
  border-top-left-radius: 33px;
  border-top-right-radius: 33px;
}

.tbHeader {
  display: flex;
  justify-content: center;
  align-items: center;

  .tbHeader_label {
    margin-right: 10px;
  }
}

.tb_col_etf {
  color: $purple_color;
  font-weight: bold;
}

.tb_col_score {
  color: $str_grey_color;
}

#mf_checkbox-1 {
  color: $purple_color;
  height: 30px;
  width: 30px;
}

.table > :not(:first-child) {
  border-top: none !important;
}

// ===========================
.mf_purple_info {
  font-weight: bold;
  color: $purple_color;
  font-size: 1.5em;
}

.mf_sm_img {
  height: 35vh;
}

.form-select {
  color: $lt_grey_color;
  border: none !important;
  border-radius: 50px !important;
  background-color: $bg_color !important;
  height: 40px;
  width: 100%;
}

option {
  border-radius: 30px !important;
  background-color: $bg_color !important;

  &:hover {
    background-color: #9561e2 !important;
  }
}

.mf_spacing {
  margin-top: 20px;
  margin-bottom: 20px;
}

.mf_bg {
  box-shadow: $boxShadow;
  background-color: $bg_color;
  border-radius: 33px;
  text-align: center;
}

.mf_bg_bl {
  box-shadow: $boxShadow;
  background-color: $bg_color_bl !important;
  border-radius: 33px;
  text-align: center;
}

.mf_btn {
  background-color: transparent !important;
}

.mf_icon_purple {
  color: $purple_color !important;
}

.mf_1row {
  text-align: initial;

  .fp_mockup {
    height: 100%;
    width: 100%;
  }
  .mf_fp_col_title {
    align-self: center;

    .mf_title {
      font-weight: bold;
      font-size: 3.5vmin;
    }

    .mf_xtra {
      color: $purple_color;
      display: flex;
      font-size: 2vmin;
      font-weight: bold;
      justify-content: flex-end;
    }

    .mf_subtitle {
      color: #707070;
      font-weight: bold;
      font-size: 2.5vmin;
    }

    .mf_title_text {
      color: $lt_grey_color;
      font-size: 2.5vmin;
    }
  }
}

.mf_2row {
  .fp_customRange {
    margin-left: 15px;
  }

  .fp_bloc {
    width: 60%;
    margin: auto;
    width: 60%;
    margin: auto;
    padding: 15px;
    margin-top: 20px;
    margin-bottom: 50px;
    justify-content: center;

    @extend .mf_bg;
    // padding-bottom: 0.5rem;

    .fp_bloc_content {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 100%;
    }

    .title_bloc {
      margin-bottom: 10px;
      margin-top: 10px;
      color: $lt_grey_color;
    }
  }

  button {
    box-shadow: $boxShadow;
    background: white;
    color: $purple_color;
    border: none;
    border-radius: 33px;
    width: 50px;
    font-size: 20px;
    font-weight: bold;
  }

  .fp_colImg {
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
}

.mf_3row {
  text-align: center;

  .mf_select {
    padding-right: 15px;
    padding-left: 15px;
    color: black !important;

    label {
      color: black !important;
    }
  }
}

.mf_5row {
  justify-content: center;
}
</style>
